module.exports = __webpack_public_path__ + "img/jrtitle.ba607be1.png";